import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import { IoIosInformationCircleOutline } from "react-icons/io";

import { QuestionnaireAction } from "../../store/actions";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
  Loader,
  popover,
} from "../../components";

import { Utils, UtilityArrays } from "../../config";

import "./styles.css";

const HighSchoolGrades = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);

  const { questionnaire, isLoading } = useSelector(
    (state) => state?.questionnaire
  );

  const [curriculumValues, setCurriculumValues] = useState([
    {
      value1: null,
      value2: null,
    },
  ]);

  useEffect(() => {
    dispatch(QuestionnaireAction.getQuestionnaire());
  }, []);

  useEffect(() => {
    if (questionnaire?.curriculum) {
      setCurriculumValues(
        questionnaire?.curriculumValues?.length > 0
          ? questionnaire?.curriculumValues
          : [
              {
                value1: null,
                value2: null,
              },
            ]
      );
    } else {
      navigate("/profile-builder/test-scores");
    }
  }, [questionnaire]);

  const addCurriculum = () => {
    if (curriculumValues.length >= 15) {
      message.error("You can only add up to 15 grades.");
      return;
    }

    const lastCurriculum = curriculumValues[curriculumValues.length - 1];

    if (!lastCurriculum.value1 || !lastCurriculum.value2) {
      message.error("Please fill the fields before adding another grade.");
    } else {
      setCurriculumValues([
        ...curriculumValues,
        {
          value1: null,
          value2: null,
        },
      ]);
    }
  };

  const removeCurriculum = (index) => {
    const updatedCurriculumValues = curriculumValues.filter(
      (_, i) => i !== index
    );
    setCurriculumValues(updatedCurriculumValues);
  };

  const handleCurriculumChange = (index, field, value) => {
    const updatedCurriculumValues = [...curriculumValues];
    updatedCurriculumValues[index][field] = value;
    setCurriculumValues(updatedCurriculumValues);
  };

  const validateGPAAmerica = (value) => {
    if (value === "" || value === null) return true;
    const gpa = parseFloat(value);
    console.log(gpa);
    return gpa >= 1.0 && gpa <= 4.0 && /^[0-9]+(\.[0-9]{1,2})?$/.test(value);
  };
  const validateGPAPakistan = (value) => {
    if (value === "" || value === null) return true;
    const gpa = parseFloat(value);
    console.log(gpa);
    return gpa >= 0 && gpa <= 5.0 && /^[0-9]+(\.[0-9]{1,2})?$/.test(value);
  };

  const handleNext = () => {
    const filteredCurriculumValues = curriculumValues.filter((curriculum) => {
      if (
        (questionnaire?.curriculumValues === "British" &&
          (!curriculum.value1 || !curriculum.value2)) ||
        !curriculum?.value1
      ) {
        return false;
      }
      return true;
    });

    if (filteredCurriculumValues.length === 0) {
      message.error("Please fill in all the required fields.");
      return;
    }

    const payload = {
      userId: profileData?.id,
      curriculumValues: filteredCurriculumValues,
    };

    dispatch(
      QuestionnaireAction.addQuestionnaire(payload, (res) => {
        if (res.status === 200) {
          dispatch(
            QuestionnaireAction.getQuestionnaire(() =>
              navigate("/profile-builder/test-scores")
            )
          );
        }
      })
    );
  };

  return (
    <div className="text-black">
      <div className="header-md pl-2 flex gap-2 items-center">
        High School Grades{" "}
        <span>
          <popover.WhitePopover
            content={
              <Link
                to="https://www.calculator.net/gpa-calculator.html"
                className="!text-blue-500 font-semibold text-[24px] !underline"
                target="_blank"
              >
                Calculator Guide
              </Link>
            }
            placement="right"
          >
            <IoIosInformationCircleOutline className="text-main" />
          </popover.WhitePopover>
        </span>
      </div>
      <Spacer height={10} />
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <boxContainer.LiteBoxContainer>
          {questionnaire?.curriculum === "British" &&
            curriculumValues?.map((curriculum, index) => (
              <div className={`${index > 0 ? "mt-6" : ""} `} key={index}>
                <div className="section-header flex justify-between items-center">
                  Grade {index + 1}
                  <Buttons.RedButton
                    size="small"
                    onClick={() => removeCurriculum(index)}
                  >
                    Remove
                  </Buttons.RedButton>
                </div>
                <div className="grid grid-cols-2 gap-x-7 gap-y-6">
                  <div>
                    <questionnaireComponents.QuestionnaireLabel
                      text="Subject"
                      required
                    />
                    <Spacer height={5} />
                    <inputFields.SelectDropdown
                      onChange={(e) =>
                        handleCurriculumChange(index, "value1", e)
                      }
                      items={Utils.filterArray(
                        UtilityArrays?.curriculumSubjects
                      )}
                      placeholder="Enter value"
                      value={curriculum?.value1}
                    />
                  </div>
                  <div>
                    <questionnaireComponents.QuestionnaireLabel
                      text={
                        "Grade"
                        // profileData?.student?.grade ===
                        //   "10 (E.G. O-level First Year)" ||
                        // profileData?.student?.grade ===
                        //   "11 (E.G. O-level Second Year)"
                        //   ? "IGCSE"
                        //   : "AS & A Level"
                      }
                    />
                    <Spacer height={5} />
                    <inputFields.SelectDropdown
                      onChange={(e) =>
                        handleCurriculumChange(index, "value2", e)
                      }
                      items={
                        Utils.filterArray(UtilityArrays?.currculumGrade2)
                        // profileData?.student?.grade ===
                        //   "10 (E.G. O-level First Year)" ||
                        // profileData?.student?.grade ===
                        //   "11 (E.G. O-level Second Year)"
                        //   ? Utils.filterArray(UtilityArrays?.currculumGrade1)
                        //   : Utils.filterArray(UtilityArrays?.currculumGrade2)
                      }
                      placeholder="Enter value"
                      value={curriculum?.value2}
                    />
                  </div>
                </div>
              </div>
            ))}
          {questionnaire?.curriculum === "British" &&
            curriculumValues.length < 15 && (
              <div className="flex justify-end mt-6">
                <Buttons.DefaultButton onClick={addCurriculum} size="medium">
                  + Add More
                </Buttons.DefaultButton>
              </div>
            )}
          {(questionnaire?.curriculum === "American" ||
            questionnaire?.curriculum === "Pakistan FBISE") && (
            <div>
              <questionnaireComponents.QuestionnaireLabel text="GPA" required />
              <Spacer height={5} />
              <inputFields.DefaultInput
                width="25em"
                onChange={(e) => {
                  const value = e.target.value;
                  if (
                    (questionnaire?.curriculum === "American" &&
                      validateGPAAmerica(value)) ||
                    (questionnaire?.curriculum === "Pakistan FBISE" &&
                      validateGPAPakistan(value))
                  ) {
                    setCurriculumValues([{ value1: value, value2: null }]);
                  } else {
                    message.error("Please enter a valid GPA");
                  }
                }}
                placeholder={
                  questionnaire?.curriculum === "American"
                    ? "1.0 - 4.0"
                    : "0 - 5.0"
                }
                type="number"
                value={curriculumValues[0]?.value1}
              />
            </div>
          )}

          {questionnaire?.curriculum === "Other" && (
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Please enter your curriculum. We will work on adding it to our application shortly."
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                width="25em"
                onChange={(e) =>
                  setCurriculumValues([
                    { value1: e.target.value, value2: null },
                  ])
                }
                placeholder="Enter value"
                value={curriculumValues[0]?.value1}
              />
            </div>
          )}

          <Spacer height={20} />
          <div className="flex justify-end">
            <div className="w-[12.5em]">
              <Buttons.DefaultButton
                onClick={handleNext}
                size="large"
                width="full"
              >
                Next
              </Buttons.DefaultButton>
            </div>
          </div>
        </boxContainer.LiteBoxContainer>
      )}
    </div>
  );
};

export default HighSchoolGrades;
